import { Component } from '@angular/core';
import Intercom from '@intercom/messenger-js-sdk';
import { TranslocoService } from '@ngneat/transloco';
import { ConnectionService } from './services/connection.service';
import { InformationalLoadingService } from './services/informational-loading.service';
import { NotificationService } from './services/notification.service';
import { UserRoleService } from './services/user-role.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(
    public infoLoading: InformationalLoadingService,
    private connectionService: ConnectionService,
    private userRoleService: UserRoleService,
    private notificationService: NotificationService,
    private translocoService: TranslocoService,
  ) {
    this.connectionService.onLine$.subscribe((onLine: boolean | null) => {
      if (onLine === false) {
        this.notificationService.displayWarning(
          this.t('It appears you have lost internet access. Please restore your connection before continuing.'),
        );
      }

      if (onLine === true) {
        this.notificationService.displayInfo(this.t('Network connection restored!'));
      }
    });

    this.userRoleService.profile$.subscribe((user) => {
      if (!user) {
        return;
      }

      if (user.intercomHash) {
        Intercom({
          app_id: 'ho3945zl',
          email: user.email,
          name: user.firstName + ' ' + user.lastName,
          user_id: user.uuid,
          user_hash: user.intercomHash,
          created_at: new Date(user.dateCreated).getTime(),
          hide_default_launcher: true,
        });
      } else {
        Intercom({
          app_id: 'ho3945zl',
          hide_default_launcher: true,
        });
      }
    });
  }

  t(text: string) {
    return this.translocoService.translate('app.' + text);
  }
}
